var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBusinessName(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4998 22.1667H26.8332V24.5H1.1665V22.1667H3.49984V4.66667C3.49984 4.02234 4.02218 3.5 4.6665 3.5H16.3332C16.9775 3.5 17.4998 4.02234 17.4998 4.66667V22.1667H22.1665V12.8333H19.8332V10.5H23.3332C23.9775 10.5 24.4998 11.0223 24.4998 11.6667V22.1667ZM5.83317 5.83333V22.1667H15.1665V5.83333H5.83317ZM8.1665 12.8333H12.8332V15.1667H8.1665V12.8333ZM8.1665 8.16667H12.8332V10.5H8.1665V8.16667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessName);
export default __webpack_public_path__ + "static/media/business-name.368bf256348ddc7547d973f201c27015.svg";
export { ForwardRef as ReactComponent };